module.exports = __webpack_public_path__ + "img/business_hero_MO.a1d4654.png";